import { gql } from '@apollo/client';

export const GET_TMS_TRANSIT_ROUTES = gql`
    query GetTmsTransitRoutes($filters: TmsTransitRouteFiltersInput, $pageRequest: PageRequestTypeInput) {
        getTmsTransitRoutes(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                originHubId
                destinationHubId
                status
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface TmsTransitRouteType {
    id: string;
    originHubId: string;
    destinationHubId: string;
    status: number;
    createdAt: string;
    updatedAt: string;
}

export interface TmsTransitRouteFiltersInput {
    originHubId?: string;
    destinationHubId?: string;
    status?: number;
    updatedStart?: string;
    updatedEnd?: string;
}

export interface GetTmsTransitRoutesResponse {
    getTmsTransitRoutes: {
        content: TmsTransitRouteType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}